import deleteData from "../services/deleteData";
import fetchData from "../services/fetchData";
import patchData from "../services/patchData";
import postData from "../services/postData";
import putData from "../services/putData";

const handleFetchServices = async () => {
  const uri = `v1/services`;
  const response = fetchData({ uri });
  return response;
};

const handleCreateService = async (data: any) => {
  const uri = `v1/services`;
  const response = postData({ data, uri });
  return response;
};

const handleUpdateService = async ({ data, _id }: any) => {
  const uri = `v1/services/${_id}`;
  const response = patchData({ data, uri });
  return response;
};

const handleCountServices = async ({ data, _id }: any) => {
  const uri = `v1/services/count/all`;
  const response = putData({ data, uri });
  return response;
};

const handleExportServices = async ({ data, _id }: any) => {
  const uri = `v1/services/export/all`;
  const response = putData({ data, uri });
  return response;
};

const handleDeleteService = async ({ _id }: any) => {
  const uri = `v1/services/${_id}`;
  const response = deleteData({ uri });
  return response;
};

export {
  handleFetchServices,
  handleCreateService,
  handleUpdateService,
  handleDeleteService,
  handleCountServices,
  handleExportServices,
};
